// src/redux/user/userSlice.js

import { createActions, createReducer } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  fetchingUserRequest: [],
  updatingUserRequest: ['userData'],
  creatingUserRequest:['userData'],
  uploadingProfilePictureRequest: ['file'],
  deletingUserProfilePictureRequest: ['publicId'],
  searchingUsersRequest: ['q', 'role'],

  userSuccess: ['user'],
  updateSuccess: ['user'],
  uploadProfilePictureSuccess: ['imageURL'],
  createSuccess: ['data'],
  deleteUserProfilePictureSuccess: ['message'],
  searchingUsersSuccess: ['data'],

  userFailure: ['error'],
  updateFailure: ['error'],
  createFailure: ['error'],
  uploadProfilePictureFailure: ['error'],
  deleteUserProfilePictureFailure: ['error'],
  searchingUsersFailure: ['error'],

})

export const UserTypes = Types
export const UserActions = Creators

/* ------------- Initial State ------------- */

const INITIAL_STATE = {
  loading: false,
  uploadingProfilePicture: false,
  deletingProfilePicture: false,
  updating: false,
  creating: false,
  searchingUsers: false,

  user: null,
  updatedUser: null,
  uploadProfilePictureSuccess: null,
  userCreated: null,
  deletedUserProfilePicture: null,
  searchedUsers: null,

  error: null,
  updatedUserError: null,
  createdError: null,
  uploadProfilePictureError: null,
  deleteUserProfilePictureError: null,
  searchedUsersError: null,
}

/* ------------- Reducers ------------- */
/*request*/

const fetchingUserRequest = (state) => ({
  ...state,
  loading: true,
  error: null,
})

const updatingUserRequest = (state) => ({
  ...state,
  updating: true,
  updatedUserError: null,
})

const creatingUserRequest = (state) => ({
  ...state,
  creating: true,
  createdError: null,
})

const uploadingProfilePictureRequest = (state) => ({
  ...state,
  uploadingProfilePicture: true,
  uploadProfilePictureError: null,
})

const deletingUserProfilePictureRequest = (state) => ({
  ...state,
  deletingProfilePicture: true,
  deleteUserProfilePictureError: null,
})

const searchingUsersRequest = (state) => ({
  ...state,
  searchingUsers: true,
  searchedUsersError: null,
})

/*success*/

const userSuccess = (state, action) => {
  const { user } = action
  return {...state, user, loading: false, error: null}
}

const updateSuccess = (state, action) => {
  const { user } = action
  return {...state, updatedUser: user, updating: false, updatedUserError: null}
}

const createSuccess = (state, action) => {
  const { data } = action
  return {...state, userCreated: data, creating: false, createdError: null}
}

const uploadProfilePictureSuccess = (state, action) => {
  const { imageURL } = action
  return {...state, uploadProfilePictureSuccess: imageURL, uploadingProfilePicture: false, uploadProfilePictureError: null}
}

const deleteUserProfilePictureSuccess = (state, action) => {
  const { message } = action
  return {...state, deletingProfilePicture: false, deletedUserProfilePicture: message,  deleteUserProfilePictureError: null}
}

const searchingUsersSuccess = (state, action) => {
  const { data } = action
  return {...state, searchingUsers: false, searchedUsers: data, searchedUsersError: null}
}

/*failure*/

const userFailure = (state, action) => {
  const { error } = action
  return {...state, user:null , loading: false, error}
}

const updateFailure = (state, action) => {
  const { error } = action
  return {...state, updatedUser:null , updating: false, updatedUserError: error}
}

const createFailure = (state, action) => {
  const { error } = action
  return {...state, userCreated: null, creating: false, createdError: error}
}

const uploadProfilePictureFailure = (state, action) => {
  const { error } = action
  return {...state, uploadProfilePictureSuccess: null, uploadingProfilePicture: false, uploadProfilePictureError: error}
}

const deleteUserProfilePictureFailure = (state, action) => {
  const { error } = action
  return {...state, deletingProfilePicture: false, deletedUserProfilePicture: null,  deleteUserProfilePictureError: error}
}

const searchingUsersFailure = (state, action) => {
  const { error } = action
  return {...state, searchingUsers: false, searchedUsers: null, searchedUsersError: error}
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(INITIAL_STATE, {
  [Types.FETCHING_USER_REQUEST]: fetchingUserRequest,
  [Types.CREATING_USER_REQUEST]: creatingUserRequest,
  [Types.UPDATING_USER_REQUEST]: updatingUserRequest,
  [Types.UPLOADING_PROFILE_PICTURE_REQUEST]: uploadingProfilePictureRequest,
  [Types.DELETING_USER_PROFILE_PICTURE_REQUEST]: deletingUserProfilePictureRequest,
  [Types.SEARCHING_USERS_REQUEST]: searchingUsersRequest,

  [Types.USER_SUCCESS]: userSuccess,
  [Types.CREATE_SUCCESS]: createSuccess,
  [Types.UPDATE_SUCCESS]: updateSuccess,
  [Types.UPLOAD_PROFILE_PICTURE_SUCCESS]: uploadProfilePictureSuccess,
  [Types.DELETE_USER_PROFILE_PICTURE_SUCCESS]: deleteUserProfilePictureSuccess,
  [Types.SEARCHING_USERS_SUCCESS]: searchingUsersSuccess,

  [Types.USER_FAILURE]: userFailure,
  [Types.CREATE_FAILURE]: createFailure,
  [Types.UPDATE_FAILURE]: updateFailure,
  [Types.UPLOAD_PROFILE_PICTURE_FAILURE]: uploadProfilePictureFailure,
  [Types.DELETE_USER_PROFILE_PICTURE_FAILURE]: deleteUserProfilePictureFailure,
  [Types.SEARCHING_USERS_FAILURE]: searchingUsersFailure,
})
